import { render, staticRenderFns } from "./Workteam.vue?vue&type=template&id=4514fa68&scoped=true"
import script from "./Workteam.vue?vue&type=script&lang=js"
export * from "./Workteam.vue?vue&type=script&lang=js"
import "./Workteam.vue?vue&type=style&index=0&id=4514fa68&prod&lang=stylus&scoped=true"
import "./Workteam.vue?vue&type=style&index=1&id=4514fa68&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4514fa68",
  null
  
)

export default component.exports